import getIframeUrl from './services/getIframeUrl';
import lockedContent from '../locked-content';
import getLoginRedirectionLink from '../locked-content/services/getLoginRedirectionLink';

function parseVideo(video: HTMLVideoElement, shouldLockVideos: boolean = false) {
  const iframeUrl = getIframeUrl((video as any).src);
  if (!iframeUrl) return;

  const iframe = document.createElement('iframe');
  iframe.classList.add('oc-video__iframe');
  iframe.setAttribute('aria-labelledby', 'course-title');

  const iframeWrapper = document.createElement('div');
  iframeWrapper.classList.add('oc-video');

  iframe.src = iframeUrl;
  iframe.setAttribute('allowFullScreen', '');

  if (shouldLockVideos) {
    lockedContent.lock.init(iframe, video as any, getLoginRedirectionLink());
  } else {
    iframeWrapper.appendChild(iframe);
    video.parentNode?.insertBefore(iframeWrapper, video);
  }

  video.parentNode?.removeChild(video);
}

const init = (domContainer: HTMLElement, shouldLockVideos = false) => {
  const videosToParse = Array.from(domContainer.getElementsByTagName('video'));
  videosToParse.forEach((video) => parseVideo(video, shouldLockVideos));
};

export default { init, parseVideo };
